const DesktopNav = (props) => {
  return (
    <div className="desktop-nav">
      <span
        className={
          props.CreditsTabIsSelected ? "indicator translated" : "indicator"
        }
      ></span>
      <section
        id="profile-tab-item"
        onClick={() => props.SwitchTab(false)}
        className={props.CreditsTabIsSelected ? "nav-row" : "nav-row active"}
      >
        <span className="row-icon first-icon"></span>
        <p>Profile</p>
      </section>
      <section
        id="credits-tab-item"
        onClick={() => props.SwitchTab(true)}
        className={!props.CreditsTabIsSelected ? "nav-row" : "nav-row active"}
      >
        <span className="row-icon second-icon"></span>
        <p>Credit overview</p>
      </section>
    </div>
  );
};

export default DesktopNav;
